import React, { useEffect, useState } from "react";
import Axios from "axios";
import {
  FontIcon,
  DefaultButton,
  PrimaryButton,
  mergeStyleSets,
} from "@fluentui/react";

import PictureAndUpload from "./common/PictureAndUpload";
import { AuthProvider } from "../../AuthProvider";
import ApiSpinner from "../common/ApiSpinner";
import { MODALITY } from "../../models/WorkPacket";
import { useHistory } from "react-router-dom";

const classes = mergeStyleSets({
  container: {
    padding: 35,
    width: 520,
  },
  header: {
    display: "flex",
    flex: "1 1 auto",
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 23,
    alignItems: "center",
    letterSpacing: "0.0015em",
    color: "#E64A19",
  },
});

const videoConstraints = {
  width: 698,
  height: 523,
  facingMode: "user",
};

interface IProps {
  onCancel(): void;
  onCloseSuccess(): void;
  nominationNo: string;
}

const RejectionImageUploadModal = ({
  onCancel,
  onCloseSuccess,
  nominationNo,
}: IProps) => {
  const [files, setFiles] = useState<any[]>([]);
  const [filePayload, setFilePayload] = useState<any>();
  const [issueDescription, setIssueDescription] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [modality, setModality] = useState<MODALITY>("MARINE");
  const history = useHistory();


  const onClose = () => {
    onCancel();
  };

  const uploadFile = async (payload: any) => {
    try {
      setSubmit(true);
      if (issueDescription.length && filePayload) {
        let data = {
          ...payload,
          issue: issueDescription,
        };
        setIsUploading(true);
        const token = await AuthProvider.getIdToken();
        setHasError(false);
        const options = {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token.idToken.rawIdToken}`,
          },
        };

        const upload = await Axios.post(
          `/api/Nomination/${nominationNo}/reject`,
          JSON.stringify(data),
          options
        );

        if (upload.data) {
          onCloseSuccess();
        }
      }
    } catch {
      setIsUploading(false);
      setHasError(true);
    }
  };

  useEffect(() => {
    if (files.length > 0) {
      console.log(files, "files");
      if (files[0].size) {
        let reader = new FileReader();

        reader.readAsDataURL(files[0]);
        reader.onload = async () => {
          const base64String = reader.result;
          setFilePayload({
            fileName: files[0].name,
            fileSize: files[0].size,
            content: base64String,
            type: files[0].type,
          });
        };
      } else {
        setFilePayload({
          fileName: files[0].name,
          content: files[0].preview,
          type: files[0].type,
        });
      }
    }
  }, [files]);

  useEffect(() => {
    if (history.location.pathname.indexOf("truck") >= 0) {
      setModality("TRUCK");
    } else {
      setModality("RAIL");
    }
  },[])

  return (
    <div className="modal-bg">
      <div className={`modal-rejection`}>
        <div className="header">
          <span className={classes.title}>Notify Supervisor</span>
          <button
            disabled={isUploading}
            className="btn-close"
            onClick={onClose}
          >
            <FontIcon iconName="cancel" />
          </button>
        </div>

        <div className="content">
          <h3>
            Based on your response, <b>DO NOT LOAD THE CARGO TANK.</b>
          </h3>
          <h3>Halt work on {modality === "TRUCK" ? "truck" : "rail"} and wait for shift supervisor to arrive.</h3>
          <div className="input-wrapper">
            <label>Brief Description of Issue</label>
            <input
              className={`form-control ${
                submit && issueDescription.length === 0 ? "has-error" : ""
              }`}
              type="text"
              value={issueDescription}
              onChange={(e) => {
                setIssueDescription(e.target.value);
              }}
              placeholder="Please provide a brief description of the issue"
            />
            {submit && issueDescription.length === 0 && (
              <p className="error-txt">Issue is required</p>
            )}
          </div>

          <PictureAndUpload
            {...{
              isUploading: isUploading,
              hasError: hasError,
              requiredState: submit && files.length === 0,
              files,
              setFiles,
            }}
          />
        </div>
        <div className="footer">
          <DefaultButton
            onClick={onClose}
            disabled={isUploading}
            className="action-button-submit"
          >
            Back
          </DefaultButton>
          <PrimaryButton
            type="submit"
            className="action-button-submit"
            disabled={isUploading}
            onClick={() => uploadFile(filePayload)}
          >
            {isUploading ? <ApiSpinner /> : "Notify Supervisor"}
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

export default RejectionImageUploadModal;
